import { axiosObject } from "../config";

function requestContactDetail(data: any) {
  return new Promise((resolve, reject) => {
    let uri = "auction/request-contact-detail";

    axiosObject
      .post(uri, data)
      .then(async (response) => {
        resolve(response.data);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}

export default requestContactDetail;
